/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CircleDotted(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CircleDotted',
      'aria-hidden': true,
      focusable: false,
      width:  10 * scale,
      height: 9 * scale,
      viewBox: '0 0 10 9',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M4.304 1.19a3.1 3.1 0 0 0-.905.38L2.681.847A4.1 4.1 0 0 1 4.304.168zm2.406.38a3.1 3.1 0 0 0-.906-.38V.169a4.1 4.1 0 0 1 1.624.678zm1.43 1.985a3.2 3.2 0 0 0-.375-.918l.72-.726c.334.484.569 1.042.677 1.644zm-.375 2.419a3.2 3.2 0 0 0 .376-.919h1.02A4.2 4.2 0 0 1 8.486 6.7zM5.804 7.42a3.1 3.1 0 0 0 .906-.38l.718.725a4.1 4.1 0 0 1-1.624.678zM3.4 7.04q.416.258.904.38v1.023a4.1 4.1 0 0 1-1.623-.678zM1.968 5.055a3.2 3.2 0 0 0 .376.919l-.72.726a4.2 4.2 0 0 1-.677-1.645zm0-1.5a3.2 3.2 0 0 1 .376-.918l-.72-.726a4.2 4.2 0 0 0-.677 1.644z","fill":"currentColor"}))
}
